export default __webpack_public_path__ + "static/media/MapTrifold.a0326e3c.svg";